import type { GlobalAppStateStoreInstance } from './GlobalAppStateStore/selectors';
import type { AppContext, AppService } from './types';

// Module-mutable for test injection; prod starts empty.
export const APP_SERVICES: AppService[] = [];

export interface AppInit {
  readonly gas: GlobalAppStateStoreInstance;
}

export interface AppHandle {
  readonly ctx: AppContext;
  dispose(): void;
}

// Takes an already-created gas store. Owns only the lifecycle of services/signal.
// BaseGlobalAppStateStoreProvider keeps its existing useState-based creation.
export function createApp(init: AppInit): AppHandle {
  const ac = new AbortController();
  const disposers: (() => void)[] = [];

  const ctx: AppContext = {
    signal: ac.signal,
    stores: { gas: init.gas },
  };

  for (const Service of APP_SERVICES) {
    const disposer = Service(ctx);
    if (typeof disposer === 'function') disposers.push(disposer);
  }

  return {
    ctx,
    dispose() {
      ac.abort();
      for (const disposer of disposers.slice().reverse()) disposer();
    },
  };
}
